import React from "react";
import HealthDashboard from "../components/HealthDashboard/HealthDashboard";

export default function HealthDashboardView() {
  return <HealthDashboard />;
}
